import { Component, HostBinding, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import * as webPlayer from '../../actions/web-player';

@Component({
  selector: 'edge-header-webplayer',
  templateUrl: './header-webplayer.component.html',
  styleUrls: ['./header-webplayer.component.scss']
})
export class GlobalHeaderWebplayerComponent {
  webPlayerSet: boolean;
  webPlayerIsSet$: Observable<boolean>;
  sportSelected$: Observable<string>;
  isSoccer: boolean;
  isFootball: boolean;
  selectedSport: string;
  dropDown: boolean = false;

  constructor(
    private store: Store<fromRoot.State>,
    private router: Router
  ) {
    this.webPlayerIsSet$ = store.select(fromRoot.webPlayerIsSet);
    if (this.webPlayerIsSet$) {
      this.webPlayerIsSet$.subscribe((isSet) => {
        this.webPlayerSet = isSet;
      });
    }
    this.sportSelected$ = store.select(fromRoot.webPlayerSport);
    if (this.sportSelected$) {
      this.sportSelected$.subscribe((sport) => {
        this.isSoccer = sport === 'soccer';
        this.isFootball = sport === 'football';
        this.selectedSport = sport;
      });
    }
  }

  toggleDropdown(toggle: boolean): void {
    this.store.dispatch(webPlayer.ToggleWebPlayerDropdownAction(toggle));
  }

  selectWebPlayer(): void {
    if (this.selectedSport) {
      this.store.dispatch(
        webPlayer.RedirectWebPlayerAction(this.selectedSport)
      );
    }

    if (this.dropDown) {
      this.dropDown = false;
      this.toggleDropdown(this.dropDown);
    }
  }

  selectGear(): void {
    this.dropDown = !this.dropDown;
    this.toggleDropdown(this.dropDown);
  }

  setWebPlayer(sport: string): void {
    this.selectedSport = sport;
    if (this.selectedSport) {
      this.store.dispatch(
        webPlayer.ToggleWebPlayerSportAction(this.selectedSport)
      );
      this.dropDown = false;
      this.toggleDropdown(this.dropDown);
    }
  }
}
